import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import HeroProductPreview from './HeroProductPreview';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  const handleGetStarted = () => {
    window.dispatchEvent(new CustomEvent('openRegisterModal'));
  };

  const scrollToHow = () => {
    const el = document.getElementById('how');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="landing-hero position-relative py-4 py-md-5"
      aria-labelledby="hero-headline"
    >
      <div className="hero-gradient" />

      <div className="container position-relative" style={{ zIndex: 1 }}>
        <div className="row align-items-center g-3 g-md-4">
          <div className="col-lg-7">
            <div
              className="d-inline-flex align-items-center px-3 py-2 rounded-pill mb-3 landing-eyebrow animate-fade-in-up"
              style={{
                backgroundColor: 'var(--accent-primary-muted)',
                border: '1px solid rgba(242, 202, 80, 0.35)',
                color: 'var(--accent-primary)',
              }}
            >
              <span>{t('landing.hero.eyebrow')}</span>
            </div>

            <h1
              id="hero-headline"
              className="fw-semibold mb-3 animate-fade-in-up"
              style={{
                fontFamily: 'var(--font-display)',
                color: 'var(--text-primary)',
                animationDelay: '200ms',
              }}
            >
              {t('landing.hero.headline')}
            </h1>

            <p
              className="landing-hero__sub mb-3 animate-fade-in-up"
              style={{
                color: 'var(--text-secondary)',
                animationDelay: '300ms',
              }}
            >
              {t('landing.hero.sub')}
            </p>

            <div
              className="d-flex flex-wrap gap-2 gap-md-3 mb-3 animate-fade-in-up"
              style={{ animationDelay: '400ms' }}
            >
              <button
                type="button"
                className="cta-button px-3 py-2 px-md-4 py-md-3 min-h-[44px]"
                onClick={handleGetStarted}
                data-testid="hero-cta-primary"
              >
                <span className="d-flex align-items-center gap-2">
                  {t('landing.cta.primary')}
                  <span className="rtl-mirror">
                    <ArrowRight size={18} />
                  </span>
                </span>
              </button>
              <button
                type="button"
                className="cta-button cta-button-secondary px-3 py-2 px-md-4 py-md-3 min-h-[44px]"
                onClick={scrollToHow}
                data-testid="hero-cta-secondary"
              >
                <span>{t('landing.cta.secondaryFallback')}</span>
              </button>
            </div>

            <p
              className="small mb-2 animate-fade-in-up"
              style={{
                color: 'var(--text-secondary)',
                animationDelay: '500ms',
                maxWidth: 600,
              }}
            >
              {t('landing.hero.trust')}
            </p>

            <p
              className="small mb-0 animate-fade-in-up landing-disclaimer__body"
              style={{
                color: 'var(--text-muted)',
                animationDelay: '550ms',
                maxWidth: 600,
              }}
            >
              {t('landing.hero.disclaimer')}
            </p>
          </div>

          <div
            className="col-lg-5 animate-fade-in-up"
            style={{ animationDelay: '300ms' }}
          >
            <HeroProductPreview />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
